export const INFRASTRUCTURE = {
  TAB_infrastructure_hostDetail_selected: 'TAB_infrastructure_hostDetail_selected',
  TAB_infrastructure_processDetail_selected: 'TAB_infrastructure_processDetail_selected',
  TAB_infrastructure_containerDetail_selected: 'TAB_infrastructure_containerDetail_selected',
  TAB_infrastructure_networkDeviceDetail_selected:
    'TAB_infrastructure_networkDeviceDetail_selected',
  TAB_infrastructure_networkObjectDetail_selected:
    'TAB_infrastructure_networkObjectDetail_selected',
  TAB_infrastructure_gpuResourceView_selected: 'TAB_infrastructure_gpuResourceView_selected',
  OPTION_infrastructure_gpuResourceView_rangeDistribution:
    'OPTION_infrastructure_gpuResourceView_rangeDistribution',
  INFRASTRUCTURE_HOST_DETAIL_DASHBOARD_SETTING_LIST:
    'INFRASTRUCTURE_HOST_DETAIL_DASHBOARD_SETTING_LIST',
  INFRASTRUCTURE_CONTAINER_DETAIL_DASHBOARD_SETTING_LIST:
    'INFRASTRUCTURE_CONTAINER_DETAIL_DASHBOARD_SETTING_LIST',
  INFRASTRUCTURE_NETWORK_DEVICE_DETAIL_DASHBOARD_SETTING_LIST:
    'INFRASTRUCTURE_NETWORK_DEVICE_DETAIL_DASHBOARD_SETTING_LIST',
  // TODO: 공통으로 들어가는 것이라 container_변경
  GRIDCOLUMNS_infrastructure_relationalInformation_targetList:
    'GRIDCOLUMNS_infrastructure_relationalInformation_targetList',

  GRIDCOLUMNS_infrastructure_host_hostList: 'GRIDCOLUMNS_infrastructure_host_hostList',
  GRIDCOLUMNS_infrastructure_hostDetail_agent_agentList:
    'GRIDCOLUMNS_infrastructure_hostDetail_agent_agentList',
  GRIDCOLUMNS_infrastructure_hostDetail_container_containerList:
    'GRIDCOLUMNS_infrastructure_hostDetail_container_containerList',
  GRIDCOLUMNS_infrastructure_hostDetail_information_memoryList:
    'GRIDCOLUMNS_infrastructure_hostDetail_information_memoryList',
  GRIDCOLUMNS_infrastructure_hostDetail_disk_diskList:
    'GRIDCOLUMNS_infrastructure_hostDetail_disk_diskList',
  GRIDCOLUMNS_infrastructure_hostDetail_installedPackage_packageList:
    'GRIDCOLUMNS_infrastructure_hostDetail_installedPackage_packageList',
  GRIDCOLUMNS_infrastructure_hostDetail_network_networkList:
    'GRIDCOLUMNS_infrastructure_hostDetail_network_networkList',
  GRIDCOLUMNS_infrastructure_hostDetail_process_processList:
    'GRIDCOLUMNS_infrastructure_hostDetail_process_processList',
  GRIDCOLUMNS_infrastructure_hostDetail_process_information_informationList:
    'GRIDCOLUMNS_infrastructure_hostDetail_process_information_informationList',
  GRIDCOLUMNS_infrastructure_hostDetail_gpu_gpuList:
    'GRIDCOLUMNS_infrastructure_hostDetail_gpu_gpuList',
  GRIDCOLUMNS_infrastructure_gpuView_gpuDetail_processList:
    'GRIDCOLUMNS_infrastructure_gpuView_gpuDetail_processList',
  GRIDCOLUMNS_infrastructure_gpuView_gpuDetail_processList_kubernetes:
    'GRIDCOLUMNS_infrastructure_gpuView_gpuDetail_processList_kubernetes',
  GRIDCOLUMNS_infrastructure_gpuView_gpuDetail_podList:
    'GRIDCOLUMNS_infrastructure_gpuView_gpuDetail_podList',
  GRIDCOLUMNS_infrastructure_gpuView_gpuMonitoringView_gpuList:
    'GRIDCOLUMNS_infrastructure_gpuView_gpuMonitoringView_gpuList',

  GRIDCOLUMNS_infrastructure_container_containerList:
    'GRIDCOLUMNS_infrastructure_container_containerList',

  GRIDCOLUMNS_infrastructure_networkDevice_deviceList:
    'GRIDCOLUMNS_infrastructure_networkDevice_deviceList',
  GRIDCOLUMNS_infrastructure_networkdeviceDetail_interface_interfaceList:
    'GRIDCOLUMNS_infrastructure_networkdeviceDetail_interface_interfaceList',
  GRIDCOLUMNS_infrastructure_networkDevicedetail_sylog_logList:
    'GRIDCOLUMNS_infrastructure_networkDevicedetail_sylog_logList',
  GRIDCOLUMNS_infrastructure_networkDevicedetail_snmpTrap_snmpTrapList:
    'GRIDCOLUMNS_infrastructure_networkDevicedetail_snmpTrap_snmpTrapList',

  GRIDCOLUMNS_infrastructure_npmDetail_networkList:
    'GRIDCOLUMNS_infrastructure_npmDetail_networkList',

  GRIDCOLUMNS_infrastructure_scriptManager_scriptResultList:
    'GRIDCOLUMNS_infrastructure_scriptManager_scriptResultList',

  GRIDCOLUMNS_infrastructure_scriptManagerHistory_scriptHistoryList:
    'GRIDCOLUMNS_infrastructure_scriptManagerHistory_scriptHistoryList',

  FILTER_infrastructure_hostView: 'FILTER_infrastructure_hostView',
  FILTER_infrastructure_containerView: 'FILTER_infrastructure_containerView',
  FILTER_infrastructure_networkDeviceView: 'FILTER_infrastructure_networkDeviceView',
  FILTER_infrastructure_networkPerformanceMonitoringView:
    'FILTER_infrastructure_networkPerformanceMonitoringView',
  FILTER_infrastructure_gpuMonitoringView: 'FILTER_infrastructure_gpuMonitoringView',
  FILTER_infrastructure_gpuResourceView_host: 'FILTER_infrastructure_gpuResourceView_host',
  FILTER_infrastructure_gpuResourceView_k8s: 'FILTER_infrastructure_gpuResourceView_k8s',

  // GPU 모니터링 플랫폼 탭(호스트/쿠버네티스) 마지막 선택 저장 — 사용자별 재진입 시 복원.
  TAB_infrastructure_gpuMonitoringView_platform: 'TAB_infrastructure_gpuMonitoringView_platform',

  STAT_infrastructure_networkPerformanceMonitoringView:
    'STAT_infrastructure_networkPerformanceMonitoringView',
  STAT_infrastructure_networkPerformanceMonitoringView_edgeStat:
    'STAT_infrastructure_networkPerformanceMonitoringView_edgeStat',
  STAT_infrastructure_networkPerformanceMonitoringView_edge:
    'STAT_infrastructure_networkPerformanceMonitoringView_edge',
  STAT_infrastructure_networkPerformanceMonitoringView_node:
    'STAT_infrastructure_networkPerformanceMonitoringView_node',
  STAT_infrastructure_networkPerformanceMonitoringView_edgeStat_global:
    'STAT_infrastructure_networkPerformanceMonitoringView_edgeStat_global',
  STAT_infrastructure_networkPerformanceMonitoringView_edge_global:
    'STAT_infrastructure_networkPerformanceMonitoringView_edge_global',
  STAT_infrastructure_networkPerformanceMonitoringView_node_global:
    'STAT_infrastructure_networkPerformanceMonitoringView_node_global',

  POSITIONS_infrastructure_networkPerformanceMonitoringView_node_global:
    'POSITIONS_infrastructure_networkPerformanceMonitoringView_node_global',
  POSITIONS_infrastructure_networkPerformanceMonitoringView_node:
    'POSITIONS_infrastructure_networkPerformanceMonitoringView_node',

  FILTERSEARCH_infrastructure_hostView_hostList: 'FILTERSEARCH_infrastructure_hostView_hostList',
  FILTERSEARCH_infrastructure_containerView_containerList:
    'FILTERSEARCH_infrastructure_containerView_containerList',
  FILTERSEARCH_infrastructure_networkDevice_deviceList:
    'FILTERSEARCH_infrastructure_networkDevice_deviceList',
  FILTERSEARCH_infrastructure_npm_networkList: 'FILTERSEARCH_infrastructure_npm_networkList',
  FILTERSEARCH_infrastructure_hostView_hostListDetail_processList:
    'FILTERSEARCH_infrastructure_hostView_hostListDetail_processList',
  FILTERSEARCH_infrastructure_hostView_hostListDetail_networkList:
    'FILTERSEARCH_infrastructure_hostView_hostListDetail_networkList',
  FILTERSEARCH_infrastructure_hostView_hostListDetail_diskList:
    'FILTERSEARCH_infrastructure_hostView_hostListDetail_diskList',
  FILTERSEARCH_infrastructure_hostView_hostListDetail_gpuList:
    'FILTERSEARCH_infrastructure_hostView_hostListDetail_gpuList',
  FILTERSEARCH_infrastructure_gpuView_gpuDetail_processList:
    'FILTERSEARCH_infrastructure_gpuView_gpuDetail_processList',
  FILTERSEARCH_infrastructure_gpuView_gpuDetail_processList_kubernetes:
    'FILTERSEARCH_infrastructure_gpuView_gpuDetail_processList_kubernetes',
  FILTERSEARCH_infrastructure_gpuView_gpuDetail_podList:
    'FILTERSEARCH_infrastructure_gpuView_gpuDetail_podList',
  FILTERSEARCH_infrastructure_gpuView_gpuMonitoringView_gpuList:
    'FILTERSEARCH_infrastructure_gpuView_gpuMonitoringView_gpuList',
  FILTERSEARCH_infrastructure_hostView_hostListDetail_containerList:
    'FILTERSEARCH_infrastructure_hostView_hostListDetail_containerList',
  FILTERSEARCH_infrastructure_hostView_hostListDetail_installedPackageList:
    'FILTERSEARCH_infrastructure_hostView_hostListDetail_installedPackageList',
  FILTERSEARCH_infrastructure_hostView_hostListDetail_relationInformationList:
    'FILTERSEARCH_infrastructure_hostView_hostListDetail_relationInformationList',
  FILTERSEARCH_infrastructure_hostView_hostListDetail_agentList:
    'FILTERSEARCH_infrastructure_hostView_hostListDetail_agentList',
  FILTERSEARCH_infrastructure_networkDevice_deviceListDetail_interfaceList:
    'FILTERSEARCH_infrastructure_networkDevice_deviceListDetail_interfaceList',
  FILTERSEARCH_infrastructure_networkDevice_deviceListDetail_syslogList:
    'FILTERSEARCH_infrastructure_networkDevice_deviceListDetail_syslogList',
  FILTERSEARCH_infrastructure_networkDevice_deviceListDetail_snmpTrapList:
    'FILTERSEARCH_infrastructure_networkDevice_deviceListDetail_snmpTrapList',
  FILTERSEARCH_infrastructure_scriptManager_scriptResultList:
    'FILTERSEARCH_infrastructure_scriptManager_scriptResultList',
  FILTERSEARCH_infrastructure_scriptManagerHistory_scriptHistoryList:
    'FILTERSEARCH_infrastructure_scriptManagerHistory_scriptHistoryList',

  METRIC_infrastructure_hostView_hostDetail_metricChart:
    'METRIC_infrastructure_hostView_hostDetail_metricChart',
  METRIC_infrastructure_containerView_containerDetail_metricChart:
    'METRIC_infrastructure_containerView_containerDetail_metricChart',
  METRIC_infrastructure_networkDeviceView_networkDeviceDetail_metricChart:
    'METRIC_infrastructure_networkDeviceView_networkDeviceDetail_metricChart',
  METRIC_infrastructure_networkDeviceView_interfaceMetricPopup_metricChart:
    'METRIC_infrastructure_networkDeviceView_interfaceMetricPopup_metricChart',
  METRIC_infrastructure_hostView_processDetail_metricChart:
    'METRIC_infrastructure_hostView_processDetail_metricChart',
  METRIC_infrastructure_hostView_networkDetail_metricChart:
    'METRIC_infrastructure_hostView_networkDetail_metricChart',
  METRIC_infrastructure_hostView_diskDetail_metricChart:
    'METRIC_infrastructure_hostView_diskDetail_metricChart',
  // GpuMetric 차트 설정 — 지표 스코프별로 분리 저장한다(gpu 전용 / GPU·MIG 통합).
  // 구 키(_metricChart / _migMetricChart)는 스코프 정의가 달라져 폐기하고 신규 키로 대체.
  METRIC_infrastructure_gpuMonitoringView_gpuDetail_gpuMetricChart:
    'METRIC_infrastructure_gpuMonitoringView_gpuDetail_gpuMetricChart',
  METRIC_infrastructure_gpuMonitoringView_gpuDetail_gpuMigMetricChart:
    'METRIC_infrastructure_gpuMonitoringView_gpuDetail_gpuMigMetricChart',

  METRIC_infrastructure_hostView_hostDetail_metricChart_timePeriod:
    'METRIC_infrastructure_hostView_hostDetail_metricChart_timePeriod',
  METRIC_infrastructure_hostView_hostDetail_processDetail_metricChart_timePeriod:
    'METRIC_infrastructure_hostView_hostDetail_processDetail_metricChart_timePeriod',
  METRIC_infrastructure_hostView_hostDetail_networkDetail_metricChart_timePeriod:
    'METRIC_infrastructure_hostView_hostDetail_networkDetail_metricChart_timePeriod',
  METRIC_infrastructure_hostView_hostDetail_diskDetail_metricChart_timePeriod:
    'METRIC_infrastructure_hostView_hostDetail_diskDetail_metricChart_timePeriod',
  METRIC_infrastructure_hostView_hostDetail_gpuDetail_metricChart_timePeriod:
    'METRIC_infrastructure_hostView_hostDetail_gpuDetail_metricChart_timePeriod',
  METRIC_infrastructure_containerView_containerDetail_metricChart_timePeriod:
    'METRIC_infrastructure_containerView_containerDetail_metricChart_timePeriod',
  METRIC_infrastructure_networkDeviceView_networkDeviceDetail_metricChart_timePeriod:
    'METRIC_infrastructure_networkDeviceView_networkDeviceDetail_metricChart_timePeriod',
  METRIC_infrastructure_hostView_processDetail_metricChart_timePeriod:
    'METRIC_infrastructure_hostView_processDetail_metricChart_timePeriod',
  METRIC_infrastructure_hostView_networkDetail_metricChart_timePeriod:
    'METRIC_infrastructure_hostView_networkDetail_metricChart_timePeriod',
  METRIC_infrastructure_hostView_diskDetail_metricChart_timePeriod:
    'METRIC_infrastructure_hostView_diskDetail_metricChart_timePeriod',

  AI_MODE_host_hostDetail: 'AI_MODE_host_hostDetail',

  TOGGLE_infrastructure_gpuDetail_info_expanded: 'TOGGLE_infrastructure_gpuDetail_info_expanded',
  TOGGLE_infrastructure_gpuDetail_gpuStat_expanded:
    'TOGGLE_infrastructure_gpuDetail_gpuStat_expanded',
  TOGGLE_infrastructure_hostDetail_platform_expanded:
    'TOGGLE_infrastructure_hostDetail_platform_expanded',
  TOGGLE_infrastructure_hostDetail_cpu_expanded: 'TOGGLE_infrastructure_hostDetail_cpu_expanded',
  TOGGLE_infrastructure_hostDetail_memory_expanded:
    'TOGGLE_infrastructure_hostDetail_memory_expanded',
  TOGGLE_infrastructure_hostDetail_network_expanded:
    'TOGGLE_infrastructure_hostDetail_network_expanded',
  TOGGLE_infrastructure_hostDetail_userTags_expanded:
    'TOGGLE_infrastructure_hostDetail_userTags_expanded',

  TOGGLE_infrastructure_networkDeviceDetail_info_expanded:
    'TOGGLE_infrastructure_networkDeviceDetail_info_expanded',
  TOGGLE_infrastructure_scriptManagerHistoryDetail_targetInfo_expanded:
    'TOGGLE_infrastructure_scriptManagerHistoryDetail_targetInfo_expanded',
  TOGGLE_infrastructure_scriptManagerHistoryDetail_scriptInfo_expanded:
    'TOGGLE_infrastructure_scriptManagerHistoryDetail_scriptInfo_expanded',

  TOGGLE_infrastructure_networkObject_patternKey_expanded:
    'TOGGLE_infrastructure_networkObject_patternKey_expanded',
  TOGGLE_infrastructure_networkObject_excludeValue_expanded:
    'TOGGLE_infrastructure_networkObject_excludeValue_expanded',
  TOGGLE_infrastructure_networkObject_host_expanded:
    'TOGGLE_infrastructure_networkObject_host_expanded',
  TOGGLE_infrastructure_hostDetail_filesystem_expanded:
    'TOGGLE_infrastructure_hostDetail_filesystem_expanded',
  TOGGLE_infrastructure_hostDetail_eolPolicy_expanded:
    'TOGGLE_infrastructure_hostDetail_eolPolicy_expanded',
};
